import * as actionTypes from './actionTypes'

import { enqueueSnackbar } from './alert'
import assignmentAxios from '../../axios/assignment'
import { saveFileFromResponse } from '../../helpers/utils'
import { fetchEmployeeOptions } from './dropdownOptions'
import { fetchToStage } from './appraisal'

export const fetchAssignmentData = (filterOptions, appraisalType) => {
  return dispatch => {
    if (!appraisalType) {
      throw new Error('Appraisal Type is required')
    }
    const params = {
      ...filterOptions,
      page: filterOptions?.page || 1,
      perPage: filterOptions?.perPage || 10
    }
    dispatch(fetchAssignmentDataStart())
    assignmentAxios
      .get(appraisalType, {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          if (filterOptions) {
            dispatch(
              fetchToStage(filterOptions.status_id, filterOptions.structure_id, 'assignment')
            )
          }

          dispatch(setAssignmentFilter(filterOptions))
          dispatch(
            fetchAssignmentDataSuccess(pagination || {}, data || [], appraisalType, filterOptions)
          )
        }
      })
      .catch(error => {
        console.log({ ...error }, error)
        dispatch(fetchAssignmentDataFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Assignment Data Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const setAssignmentFilter = filterOptions => {
  return {
    type: actionTypes.ASSIGNMENT_SET_ASSIGN_FILTER,
    filterOptions
  }
}

export const fetchAssignmentDataStart = () => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_START
  }
}

export const fetchAssignmentDataSuccess = (pagination, records, appraisalType, filterOptions) => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_SUCCESS,
    pagination,
    records,
    appraisalType,
    filterOptions
  }
}

export const fetchAssignmentDataFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_FAILED,
    errorMessage
  }
}

export const fetchAssignmentDataById = recordId => {
  return dispatch => {
    dispatch(fetchAssignmentDataByIdStart())
    assignmentAxios
      .get(`${recordId}`)
      .then(response => {
        if (response.status === 200) {
          const { assignment_info, result_structure, ...rest } = response.data.data

          const assignmentInfo = {
            ...assignment_info,
            ...rest
            // assigned_date: rest.assigned_date
          }

          const assignmentItems = result_structure

          // const assignmentData = rest

          dispatch(fetchEmployeeOptions())

          dispatch(fetchAssignmentDataByIdSuccess(assignmentInfo, assignmentItems))
        }
      })
      .catch(error => {
        dispatch(fetchAssignmentDataByIdFailed())
      })
  }
}

const fetchAssignmentDataByIdStart = () => {
  return {
    type: actionTypes.ASSIGNMENT_FETCH_BY_ID_START
  }
}

const fetchAssignmentDataByIdSuccess = (assignmentInfo, assignmentItems) => {
  return {
    type: actionTypes.ASSIGNMENT_FETCH_BY_ID_SUCCESS,
    assignmentInfo,
    assignmentItems
    // assignmentData
  }
}

const fetchAssignmentDataByIdFailed = () => {
  return {
    type: actionTypes.ASSIGNMENT_FETCH_BY_ID_FAILED
  }
}

export const fetchAssignmentDataTemplate = options => {
  return dispatch => {
    const params = options
    dispatch(fetchAssignmentDataTemplateStart())
    assignmentAxios
      .post('structures/items/template', params)
      .then(response => {
        if (response?.status === 200) {
          const { result_structure, ...rest } = response.data.data
          const structureWithEndDate = (result_structure || []).map(st => ({
            end_date: `${new Date().getFullYear()}-12-31`,
            ...st
          }))
          dispatch(fetchAssignmentDataTemplateSuccess(structureWithEndDate))
          dispatch(setAssignmentData(rest))
        }
      })
      .catch(error => {
        switch (error?.response?.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Get Assignment Template Error',
                options: {
                  variant: 'error',
                  data: error?.response?.data?.data ?? []
                }
              })
            )
            break
          default:
            break
        }
        dispatch(fetchAssignmentDataTemplateFailed())
      })
  }
}

const fetchAssignmentDataTemplateStart = () => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_START
  }
}

const fetchAssignmentDataTemplateSuccess = data => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_SUCCESS,
    data
  }
}

const fetchAssignmentDataTemplateFailed = () => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_FAILED
  }
}

export const setAssignTarget = (empIds, appraisalType) => {
  return {
    type: actionTypes.ASSIGNMENT_SET_ASSIGN_TARGET,
    targetIds: empIds,
    appraisalType: appraisalType
  }
}

export const setAssignmentAction = action => {
  return {
    type: actionTypes.ASSIGNMENT_SET_ASSIGN_ACTION,
    action
  }
}

export const setAssignItems = selectedItemIds => {
  return {
    type: actionTypes.ASSIGNMENT_SET_ASSIGN_ITEMS,
    selectedItemIds
  }
}

export const setAssignmentData = data => {
  return {
    type: actionTypes.ASSIGNMENT_SET_ASSIGN_DATA,
    data
  }
}

export const clearAssignmentItems = () => {
  return {
    type: actionTypes.ASSIGNMENT_CLEAR_ASSIGN_ITEMS
  }
}

export const saveAssignment = data => {
  return dispatch => {
    dispatch(saveAssignmentStart())
    assignmentAxios
      .post('', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(saveAssignmentSuccess(data?.result_structure[0]?.structure_id))
          // dispatch(fetchAssignmentDataById(response.data.data[0]?.result_id))
          dispatch(
            enqueueSnackbar({
              message: 'Assignment Saved',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data?.action2
                  ? 'Error Criteria not match'
                  : 'Assignment Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break
          case 500:
            dispatch(
              enqueueSnackbar({
                message: 'Assignment Error',
                options: {
                  variant: 'error'
                }
              })
            )
            break
          default:
            break
        }
        dispatch(saveAssignmentFailed())
      })
  }
}

const saveAssignmentStart = () => {
  return {
    type: actionTypes.ASSIGNMENT_SAVE_ASSIGN_START
  }
}

const saveAssignmentSuccess = structureId => {
  return {
    type: actionTypes.ASSIGNMENT_SAVE_ASSIGN_SUCCESS,
    structureId
  }
}

const saveAssignmentFailed = () => {
  return {
    type: actionTypes.ASSIGNMENT_SAVE_ASSIGN_FAILED
  }
}

export const updateAssignment = data => {
  return dispatch => {
    dispatch(updateAssignmentStart())
    assignmentAxios
      .patch(`${data.result_id}`, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateAssignmentSuccess(data?.result_structure[0]?.structure_id))
          // dispatch(fetchAssignmentDataById(data.result_id))
          dispatch(
            enqueueSnackbar({
              message: 'Assignment Saved',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(updateAssignmentFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Update Assignment Failed',
            options: {
              variant: 'error'
            }
          })
        )
        // switch (error.response.status) {
        //   case 400:
        //     dispatch(
        //       enqueueSnackbar({
        //         message: 'Assignment Error',
        //         options: {
        //           variant: 'error',
        //           data: error.response.data.data
        //         }
        //       })
        //     )
        //     break
        //   case 500:
        //     dispatch(
        //       enqueueSnackbar({
        //         message: 'Assignment Error',
        //         options: {
        //           variant: 'error'
        //         }
        //       })
        //     )
        //     break
        //   default:
        //     break
        // }
      })
  }
}

const updateAssignmentStart = () => {
  return {
    type: actionTypes.ASSIGNMENT_UPDATE_ASSIGN_START
  }
}

const updateAssignmentSuccess = structureId => {
  return {
    type: actionTypes.ASSIGNMENT_UPDATE_ASSIGN_SUCCESS,
    structureId
  }
}

const updateAssignmentFailed = () => {
  return {
    type: actionTypes.ASSIGNMENT_UPDATE_ASSIGN_FAILED
  }
}

export const deleteAssignment = (resultId, filterOptions, appraisalType) => {
  return dispatch => {
    dispatch(deleteAssignmentStart())
    assignmentAxios
      .delete(`${resultId}`)
      .then(response => {
        if (response.status === 204) {
          dispatch(
            enqueueSnackbar({
              message: 'Delete Assignment Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
        dispatch(deleteAssignmentSuccess())
        dispatch(fetchAssignmentData(filterOptions, appraisalType))
      })
      .catch(error => {
        dispatch(deleteAssignmentFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Delete Assignment Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

const deleteAssignmentStart = () => {
  return {
    type: actionTypes.ASSIGNMENT_DELETE_ASSIGN_START
  }
}

const deleteAssignmentSuccess = () => {
  return {
    type: actionTypes.ASSIGNMENT_DELETE_ASSIGN_SUCCESS
  }
}

const deleteAssignmentFailed = () => {
  return {
    type: actionTypes.ASSIGNMENT_DELETE_ASSIGN_FAILED
  }
}

export const fetchStructureWithItems = (filterOptions, isEdit) => {
  return dispatch => {
    let params = filterOptions
    dispatch(fetchStructureWithItemsStart())
    assignmentAxios
      .get('structures/items', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { item_data, deploy_item } = response.data.data
          // const { data } = response.data

          dispatch(fetchStructureWithItemsSuccess(item_data, deploy_item))
          // dispatch(fetchStructureWithItemsSuccess(data))

          if (!isEdit) {
            dispatch(setAssignItems(deploy_item))
          }
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Fetch Structure Data Error',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(fetchStructureWithItemsFailed(error.message))
      })
  }
}

const fetchStructureWithItemsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURES_START
  }
}

const fetchStructureWithItemsSuccess = (structures, deployItemIds) => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURES_SUCCESS,
    structures,
    deployItemIds
  }
}

const fetchStructureWithItemsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURES_FAILED,
    errorMessage
  }
}

export const saveAssignmentDraft = (data, itemIds) => {
  return {
    type: actionTypes.ASSIGNMENT_SAVE_DRAFT,
    data,
    itemIds
  }
}

export const importAssignmentData = (importFile, filterOptions, appraisalType) => {
  return dispatch => {
    const { appraisal_type_code } = appraisalType
    let refreshPath = ''
    if (appraisal_type_code === 'APT01') {
      refreshPath = 'corporate'
    } else if (appraisal_type_code === 'APT02') {
      refreshPath = 'individual'
    }
    dispatch(importAssignmentStart())
    let formData = new FormData()
    formData.append('file', importFile)

    assignmentAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importAssignmentSuccess(response.data))
          dispatch(
            enqueueSnackbar({
              message: 'Assignment Data Imported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchAssignmentData(filterOptions, refreshPath))
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Import Assignment Data Error',
            options: {
              variant: 'error',
              data: error.response.data.data
            }
          })
        )
        dispatch(importAssignmentFailed(error))
      })
  }
}

const importAssignmentStart = () => {
  return {
    type: actionTypes.IMPORT_ASSIGNMENT_START
  }
}

const importAssignmentSuccess = () => {
  return {
    type: actionTypes.IMPORT_ASSIGNMENT_SUCCESS
  }
}

const importAssignmentFailed = () => {
  return {
    type: actionTypes.IMPORT_ASSIGNMENT_FAILED
  }
}

export const exportAssignmentData = filterOptions => {
  return dispatch => {
    dispatch(exportAssignmentDataStart())
    let params = null
    if (filterOptions) {
      params = filterOptions
    }
    assignmentAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(exportAssignmentDataSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Assignment Exported',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(exportAssignmentDataFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Assignment Export Failed',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const exportAssignmentDataStart = () => {
  return {
    type: actionTypes.EXPORT_ASSIGNMENT_START
  }
}

export const exportAssignmentDataSuccess = () => {
  return {
    type: actionTypes.EXPORT_ASSIGNMENT_SUCCESS
  }
}

export const exportAssignmentDataFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_ASSIGNMENT_FAILED,
    errorMessage
  }
}

export const copyAssignment = (data, appriasalType) => {
  return (dispatch, getState) => {
    const reducerName = `${appriasalType}Assignment`
    const currentFilter = getState()[reducerName]?.filtered
    dispatch(copyAssignmentStart())
    assignmentAxios
      .post('/copy', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(copyAssignmentSuccess())
          dispatch(fetchAssignmentData(currentFilter, appriasalType))
          dispatch(
            enqueueSnackbar({
              message: 'Copy Assignment Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(copyAssignmentFailed(error))
        dispatch(
          enqueueSnackbar({
            message: 'Copy Assignment Failed',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

const copyAssignmentStart = () => {
  return {
    type: actionTypes.COPY_ASSIGNMENT_START
  }
}

const copyAssignmentSuccess = () => {
  return {
    type: actionTypes.COPY_ASSIGNMENT_SUCCESS
  }
}

const copyAssignmentFailed = errorMessage => {
  return {
    type: actionTypes.COPY_ASSIGNMENT_FAILED,
    errorMessage
  }
}

export const clearFilteredAssignmentRecords = () => {
  return {
    type: actionTypes.CLEAR_FILTERED_ASSIGNMENT_RECORDS
  }
}

export const bulkDeleteAssignment = (targetIds, appraisalType) => {
  const data = {
    result_id: targetIds
  }
  return (dispatch, getState) => {
    const currentFilter = getState().assignmentFlow.filter
    dispatch(bulkDeleteAssignmentStart())
    assignmentAxios
      .delete('', { data })
      .then(response => {
        if (response.status === 204) {
          dispatch(bulkDeleteAssignmentSuccess())

          dispatch(fetchAssignmentData(currentFilter, appraisalType))

          dispatch(
            enqueueSnackbar({
              message: 'Delete Assignment Success',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete Assignment Error',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(bulkDeleteAssignmentFailed())
      })
  }
}

const bulkDeleteAssignmentStart = () => {
  return {
    type: actionTypes.BULK_DELETE_ASSIGNMENT_START
  }
}

const bulkDeleteAssignmentSuccess = () => {
  return {
    type: actionTypes.BULK_DELETE_ASSIGNMENT_SUCCESS
  }
}

const bulkDeleteAssignmentFailed = () => {
  return {
    type: actionTypes.BULK_DELETE_ASSIGNMENT_FAILED
  }
}

export const bulkUpdateAssignment = (data, filterOptions, appraisalType) => {
  return dispatch => {
    dispatch(bulkUpdateAssignmentStart())
    assignmentAxios
      .post('/approve', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(bulkUpdateAssignmentSuccess())
          dispatch(fetchAssignmentData(filterOptions, appraisalType))
        }
      })
      .catch(error => {
        dispatch(bulkUpdateAssignmentFailed())
      })
  }
}

const bulkUpdateAssignmentStart = () => {
  return {
    type: actionTypes.BULK_UPDATE_ASSIGNMENT_START
  }
}

const bulkUpdateAssignmentSuccess = () => {
  return {
    type: actionTypes.BULK_UPDATE_ASSIGNMENT_SUCCESS
  }
}

const bulkUpdateAssignmentFailed = () => {
  return {
    type: actionTypes.BULK_UPDATE_ASSIGNMENT_FAILED
  }
}

export const clearAssignmentStructure = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STRUCTURES_SUCCESS,
    structures: [],
    deployItemIds: []
  }
}
